module.exports = __webpack_public_path__ + "img/12.cdf43c10.jpg";